var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1053 23.9375V21.0625H37V23.9375H17.1053ZM17.1053 32.5625V29.6875H37V32.5625H17.1053ZM17.1053 15.3125V12.4375H37V15.3125H17.1053ZM11.4211 16.75V12.4375H10V11H12.8421V16.75H11.4211ZM10 29.6875V28.25H14.2632V34H10V32.5625H12.8421V31.8438H11.4211V30.4062H12.8421V29.6875H10ZM13.1974 19.625C13.48 19.625 13.7511 19.7386 13.951 19.9408C14.1509 20.143 14.2632 20.4172 14.2632 20.7031C14.2632 20.9906 14.1495 21.2638 13.9647 21.4506L11.5916 23.9375H14.2632V25.375H10V24.0525L12.8421 21.0625H10V19.625H13.1974Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberedList);
export default __webpack_public_path__ + "static/media/NumberedList.c1962cb3bcd60dcd8f30b09574a02a84.svg";
export { ForwardRef as ReactComponent };